import { 
  init, 
  isInitialized,
  breadcrumbsIntegration,
  replayIntegration,
  reactRouterV6BrowserTracingIntegration
} from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import React, { FC, PropsWithChildren } from 'react';

interface SentryProps extends PropsWithChildren {
}

const SentryProvider: FC<SentryProps> = ({
  children
}) => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT;
  const sessionReplaysEnabled = import.meta.env.VITE_SENTRY_SESSION_REPLAYS_ENABLED === 'true';
  const errorSampleRate = Number(
    import.meta.env.VITE_SENTRY_SESSION_REPLAYS_ERROR_SAMPLE_RATE ?? '1.0'
  );

  // Added ignore to Sentry console logs as they are unreadable and useless:
  // https://github.com/getsentry/sentry-react-native/issues/794#issuecomment-908189765

  if (dsn && !isInitialized()) {
    init({
      dsn,
      
      environment,

      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: errorSampleRate,

      integrations: [
        breadcrumbsIntegration({
          console: false
        }),
        reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        ...(sessionReplaysEnabled ? [replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
        })] : [])
      ]

    });
  }

  return children;
};

export default SentryProvider;
